/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimulationExcelFileNamesResponse
 */
export interface SimulationExcelFileNamesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof SimulationExcelFileNamesResponse
     */
    fileNames?: Array<string> | null;
}

/**
 * Check if a given object implements the SimulationExcelFileNamesResponse interface.
 */
export function instanceOfSimulationExcelFileNamesResponse(value: object): value is SimulationExcelFileNamesResponse {
    return true;
}

export function SimulationExcelFileNamesResponseFromJSON(json: any): SimulationExcelFileNamesResponse {
    return SimulationExcelFileNamesResponseFromJSONTyped(json, false);
}

export function SimulationExcelFileNamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationExcelFileNamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fileNames': json['fileNames'] == null ? undefined : json['fileNames'],
    };
}

export function SimulationExcelFileNamesResponseToJSON(json: any): SimulationExcelFileNamesResponse {
    return SimulationExcelFileNamesResponseToJSONTyped(json, false);
}

export function SimulationExcelFileNamesResponseToJSONTyped(value?: SimulationExcelFileNamesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileNames': value['fileNames'],
    };
}

